<!--
/**
* @name: Add.vue
* @description: 直播管理-直播间添加商品页面
* @author: 杨波
* @create: 2020/12/02 10:16:58
* @update: 2020/12/02 10:16:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-form titleAlign="right" titleWidth="100px" contentWidth="100%">
      <y-form-item title="商品货号:" required>
        <k-input @blur="getGoodsBasicInfo" :class="css.inputW" placeholder="请输入商品货号" :disabled="isEdit ? true : false"
                 block :clearable="isEdit ? false : true" v-model="editPara.goodsCodeSale"></k-input>
      </y-form-item>
      <y-form-item title="商品名称:" required align="top">
        <k-input :class="css.inputW" placeholder="请输入商品名称" block clearable v-model="editPara.name"></k-input>
        <div :class="css.desc" class="mt-1">商品名称，最长14个汉字，1个汉字相当于2个字符</div>
      </y-form-item>
      <y-form-item title="直播价格:" required align="top">
        <div>
          <k-input @keydown.native="clearInput" style="width: 120px; display: inline-block;" type="number" min="0"
                   placeholder="0.00" block clearable v-model="editPara.price"></k-input>
          &nbsp;&nbsp;元
        </div>
      </y-form-item>
      <y-form-item title="直播价格是否影响佣金:" required>
        <div>
          <k-radio v-model="editPara.isPriceAffectProfit" value="0">否</k-radio>
          <k-radio v-model="editPara.isPriceAffectProfit" value="1">是</k-radio>
        </div>
      </y-form-item>

      <y-form-item title="商品相册:" align="top">
        <div class="row">
          <y-upload-file fileType="image" multiple :uploadUrl="uploadUrl" @uploaded="onUploadedImg"
                         v-if="imgList.length < 6"></y-upload-file>
          <y-image @delete="onDelete" v-dragging="{ list: imgList, item: img, group: 'image' }"
                   v-for="(img, index) in imgList" :key="index" :index="index" :src="img.url"></y-image>
        </div>
        <div :class="css.desc" class="mt-1">商品描述/名称/相册可再次编辑。</div>
      </y-form-item>
      <y-form-item title="选择仓库:" required v-if="managementType == 'AAA001'">
        <k-select2 v-model="editPara.wscodeList" :data="wscodeList" search-field="wsname" text-field="wsname"
                   key-field="wscode" layer-width="auto" layerMinWidthEqual :nearby="true" placeholder="请选择仓库"
                   ref="selectBatch" style="width: 330px;">
        </k-select2>
      </y-form-item>
      <y-form-item title="是否指定批次:" required v-else>
        <div>
          <k-radio v-model="isAssign" :value="2">否</k-radio>
          <k-radio v-model="isAssign" :value="1">是</k-radio>
          <div :class="css.wrapper" v-if="isAssign == '1'">
            <k-select2 v-model="saleBatchNoList" :data="batchList" search-field="saleBatchNo" text-field="saleBatchNo"
                       key-field="saleBatchNo" layer-width="auto" layerMinWidthEqual :nearby="true"
                       placeholder="请选择适用批次号" ref="selectBatch" style="width: 330px;">
            </k-select2>
          </div>
        </div>
      </y-form-item>
      <y-form-item title="是否设立单独库存:" required>
        <div>
          <k-radio v-model="editPara.isIndependentInventory" value="0">否</k-radio>
          <k-radio v-model="editPara.isIndependentInventory" value="1">是</k-radio>
          <div :class="css.wrapper" v-if="editPara.isIndependentInventory == '1'">
            <k-input @keydown.native="clearNumertInput" style="width: 120px; display: inline-block;" type="number"
                     min="0" placeholder="请输入" block clearable v-model="editPara.stock"></k-input>
          </div>
        </div>
      </y-form-item>

      <y-form-item title="是否限制下单数量:" required>
        <div>
          <k-radio v-model="isLimitOrder" value="0">否</k-radio>
          <k-radio v-model="isLimitOrder" value="1">是</k-radio>
          <div :class="css.wrapper" v-if="isLimitOrder == '1'">
            <k-input @keydown.native="clearNumertInput" style="width: 120px; display: inline-block;" type="number"
                     min="0" placeholder="请输入" block clearable v-model="editPara.limitOrderNum"></k-input>
          </div>
        </div>
      </y-form-item>
      <y-form-item title="是否限制商品件数:" required>
        <div>
          <k-radio v-model="isLimitGoods" value="0">否</k-radio>
          <k-radio v-model="isLimitGoods" value="1">是</k-radio>
          <div :class="css.wrapper" v-if="isLimitGoods == '1'">
            <k-input @keydown.native="clearNumertInput" style="width: 120px; display: inline-block;" type="number"
                     min="0" placeholder="请输入" block clearable v-model="editPara.limitGoodsNum"></k-input>
          </div>
        </div>
      </y-form-item>

      <y-form-item title="商品描述:" align="top">
        <div :class="css.form_item">
          <ueditor v-model="editPara.description"></ueditor>
        </div>
      </y-form-item>
    </y-form>

    <div slot="bottom">
      <k-button @click="onCancel(true, false)">取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>
<script>
import {
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_EDIT_DETAIL,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_SAVE,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_UPDATE,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_SAVE_DETAIL,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  goodsCodeSale: "",
  name: "",
  isPriceAffectProfit: 0,//直播价格是否影响佣金
  price: "",
  saveGoodsSaleBroadcastPictureDTOList: [],
  batchNoList: [],
  isIndependentInventory: "",
  limitGoodsNum: '',//限制商品件数,否传0;是：传大于0表示限制商品购买的数量
  limitOrderNum: '',//限制下单数量,否传0;是：传大于0

  stock: "",
  description: "",
  wscodeList: [],
});
export default {
  data() {
    return {
      isLimitGoods: 0,//是否限制商品件数
      isLimitOrder: 0,//是否限制下单数

      isLoading: false,
      editPara: initEditPara(),
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      imgList: [],
      isAssign: "",
      saleBatchNoList: [],
      isEdit: false,
      isView: false,
      managementType: "",
      roomCode: "",
      batchList: [],
      wscodeList: [],
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      let nameLength = para.name.toString().replace(/[^\x00-\xff]/g, "AA").length;
      if (
        nameLength === 0 ||
        !para.goodsCodeSale ||
        !para.price ||
        (this.managementType == "AAA001" && para.wscodeList.length === 0) ||
        (this.managementType != "AAA001" && !this.isAssign) ||
        (this.isAssign == "1" && this.saleBatchNoList.length === 0) ||
        (!para.isIndependentInventory && para.isIndependentInventory != "0") ||
        (para.isIndependentInventory == "1" && !para.stock) ||
        (this.isLimitOrder == "1" && !para.limitOrderNum) ||
        (this.isLimitGoods == "1" && !para.limitGoodsNum)

      ) {
        status = true;
      }
      return status;
    },
  },

  watch: {
    isAssign(v) {
      if (v == "2") {
        this.saleBatchNoList = [];
      }
    },
    "editPara.isIndependentInventory"(nValue, oValue) {
      if (nValue == "0") {
        this.editPara.stock = "";
      }
    },
  },
  methods: {
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    clearNumertInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    //获取导入商品基本信息
    getGoodsBasicInfo() {
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_SAVE_DETAIL,
        para: {
          roomCode: this.roomCode,
          goodsCodeSale: this.editPara.goodsCodeSale,
        },
      }).then((res) => {
        if (!this.isEdit) {
          this.editPara.name = res.name;
          this.editPara.saveGoodsSaleBroadcastPictureDTOList = res.goodsSaleBroadcastPictureEditVOList || [];
          this.imgList = res.goodsSaleBroadcastPictureEditVOList || [];
          this.editPara.description = res.description || "";
        }
        this.managementType = res.managementType;
        this.wscodeList = res.saveVOWsCodeVOList || [];
        this.batchList = res.saveVOSaleBatchVOList || [];
      });
    },
    onUploadedImg(data) {
      let { tip } = this.$root;
      for (let i = 0; i < data.data.length; i++) {
        this.imgList.push({ url: data.data[i].url, sort: i });
      }
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "addLiveRoomGoodsList",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
            roomCode: this.roomCode,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onDelete(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.imgList.splice(obj.index, 1);
        },
      });
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let reg = /^\d+(\.\d{1,2})?$/;
      if (this.editPara.price.toString().slice(0, 1) == "0" && this.editPara.price.toString().slice(1, 2) != ".") {
        return tip("直播价格输入非小数时，首位不可以为0");
      }
      if (!reg.test(this.editPara.price)) {
        return tip("直播价格只能输入正数数字，0不可以；特殊字符不可以；最多2位小数");
      }
      let nameLength = this.editPara.name.toString().replace(/[^\x00-\xff]/g, "AA").length;
      if (nameLength > 28) {
        return tip("商品名称，最长14个汉字，1个汉字相当于2个字符");
      }
      // let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
      // let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

      // if (regEn.test(this.editPara.name) || regCn.test(this.editPara.name)) {
      //   return tip("商品名称不能包含特殊字符");
      // }
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (this.isAssign == "1") {
        para.batchNoList = this.saleBatchNoList;
      } else {
        para.batchNoList = [];
      }

      if (this.isLimitOrder == 0) {
        para.limitOrderNum = 0
      }
      if (this.isLimitGoods == 0) {
        para.limitGoodsNum = 0
      }

      para.roomCode = this.roomCode;
      if (this.isEdit) {
        para.updateGoodsSaleBroadcastPictureDTOList = this.imgList;
      } else {
        para.saveGoodsSaleBroadcastPictureDTOList = this.imgList;
      }
      delete para.goodsSaleBroadcastPictureEditVOList;
      this.isSaving = true;
      this.isLoading = false;

      this.$fetch({
        api: this.isEdit ? NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_UPDATE : NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_SAVE,
        para,
      })
        .then((res) => {
          tip("操作成功");
          this.onCancel(true, true);
          this.isSaving = false;
          this.isLoading = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    //获取直播间商品详情
    getLiveRoomGoodsDetail(roomCode, goodsCodeSale) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_BROADCAST_EDIT_DETAIL,
        para: { roomCode, goodsCodeSale },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.imgList = this.editPara.goodsSaleBroadcastPictureEditVOList || [];
          this.saleBatchNoList = this.editPara.batchNoList || [];
          this.editPara.wscodeList = res.wscodeList ? res.wscodeList : [];
          if (this.editPara.batchNoList) {
            this.isAssign = "1";
          } else {
            this.isAssign = "2";
          }
          if (res.limitOrderNum && res.limitOrderNum > 0) {
            this.isLimitOrder = 1
          } else {
            this.isLimitOrder = 0
          }
          if (res.limitGoodsNum && res.limitGoodsNum > 0) {
            this.isLimitGoods = 1
          } else {
            this.isLimitGoods = 0
          }

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    const { roomCode, goodsCodeSale, edit } = this.$route.query;
    this.roomCode = roomCode;
    if (edit) {
      this.isEdit = true;
      this.isView = false;
      this.editPara.goodsCodeSale = goodsCodeSale;
      this.getLiveRoomGoodsDetail(roomCode, goodsCodeSale);
      this.getGoodsBasicInfo();
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { roomCode, goodsCodeSale, edit } = to.query;
    this.roomCode = roomCode;
    this.editPara = initEditPara();
    this.saleBatchNoList = [];
    this.managementType = "";
    this.isAssign = "";
    this.imgList = [];
    if (edit) {
      this.isEdit = true;
      this.isView = false;
      this.editPara.goodsCodeSale = goodsCodeSale;
      this.getLiveRoomGoodsDetail(roomCode, goodsCodeSale);
      this.getGoodsBasicInfo();
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 420px !important;
}

.desc {
  color: #999;
}

.wrapper {
  display: inline-block;
  margin-left: 10px;
}

.form_item {
  max-width: 845px;
}
</style>
